
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { logout, changeState, mudarProcesso } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import { URL } from '../variables';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import Redacao from './Redacao';
import { Tab, Tabs } from 'react-bootstrap';
import { getLanguageTexts, getSelectedLanguage } from '../language';

const DecideBorder = (resposta, correta, atual) => {
    console.log(resposta,correta,atual)
    if (atual == resposta && resposta == correta) {
        return '1px solid green';
    }
    else if (atual == resposta) {
        return '1px solid red';
    }
    else if (atual == correta) {
        return '1px solid green';
    }
    else {
        return '';
    }
}

class Finalizada extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            tab: 0,

        };
        this.unmont_ = false;

    }


    componentDidMount() {
        this.props.changeStateParent({ show_face_mesh: false });
        try {

            if (this.props.stream != null) {
                console.log('finalizado stream4')

                this.props.stream.oninactive = function () { }
                this.props.stream.getTracks().map((track) => {
                    track.stop();
                })
            }
        }
        catch (e) {
            console.log(e)
        }
        try {

            if (this.props.stream_screen != null) {
                console.log('finalizado')
                this.props.stream_screen.oninactive = function () { }
                this.props.stream_screen.getVideoTracks()[0].onended = function () { }

                this.props.stream_screen.getTracks().map((track) => {

                    track.stop();
                })
            }
        }
        catch (e) {
            console.log(e)
        }

        this.props.changeState({ stream: null, stream_screen: null });
        // this.props.object_worker.terminate();
        if (this.props.processo.simulado == false) {
            this.logs_timeout = setTimeout(() => {
                this.salvar_log();
            }, this.props.processo.save_timer_pre_exam);
        }
        else {
            this.logs_timeout = setTimeout(() => {
                localStorage.removeItem('token');
                this.props.logout();
            }, 30000);
        }

       
    }

    componentWillUnmount() {
        this.unmont_ = true;

        clearTimeout(this.logs_timeout);
    }

    salvar_log() {
        fetch(`${URL}api/salvar_log?screen=finish&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (resp.status == false) {
                        this.props.get_processo();
                    }
                    else {
                        if (resp.processo != null && resp.processo.updated_at != this.props.processo.updated_at) {
                            this.props.mudarProcesso(resp.processo);
                        }
                        if (this.unmont_ == false) {

                            this.logs_timeout = setTimeout(() => {
                                this.salvar_log();
                            }, this.props.processo.save_timer_pre_exam);
                        }
                    }
                }
            } catch (err) {
                console.log(err);

                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            }

        })
            .catch((err) => {
                console.log(err);
                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            });
    }

    logout() {
        localStorage.removeItem('token');
        // this.setState({redirect:true,path:'/'});
        this.props.logout();
    }

    changeTab(k) {
        console.log(k)
        this.setState({ tab: k })
    }

    mapAlternative(alt){
        if(alt.order==1){
            return 'a)'
        }
        else if(alt.order==2){
            return 'b)'
        }
        else if(alt.order==3){
            return 'c)'
        }
        else if(alt.order==4){
            return 'd)'
        }
        else if(alt.order==5){
            return 'e)'
        }
    }

    async download_answers(id2){
        var doc = new jsPDF('l', 'px', 'a4')
        var width = doc.internal.pageSize.width - 20;
        var height = doc.internal.pageSize.height;
        doc.internal.write(0, "Tw")
        await doc.html('<div style="width:' + width + 'px;padding:10px">' + document.getElementById('resultados_' + id2).innerHTML + '</div>', {
            pagebreak: { mode: 'avoid-all', after: '.avoidThisRow' },
            html2canvas: {
                // insert html2canvas options here, e.g.
                width: doc.internal.pageSize.width,
                allowTaint: false,
                useCORS: true
            },
        });
        doc.save('suas_respostas_' + this.props.processo.name.replace(/\./g, '') + '.pdf');
    }

    render() {
        let index = 0;
        const t = getLanguageTexts(getSelectedLanguage());

        return (
            <div className="external-camera-finalized">
                <div className="external-camera-finalized-icon">
                    <i className="mdi mdi-check-circle" aria-hidden="true"></i>
                </div>
                <div>
                    <h4 className="external-camera-timer" style={{ fontSize: '1.6rem' }}>{t.evaluation_finished_success}</h4>
                    <p className="external-camera-muted">{t.external_camera_disconnected}</p>
                </div>



                <div className="external-camera-actions">
                    <button className="btn btn-danger btn-lg" onClick={this.logout.bind(this)}><i
                        className="mdi mdi-power" style={{ color: 'white' }}></i> {t.click_here_to_exit}</button>

                </div>

            </div>

        );
    }
}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        token: state.AppReducer.token,
        user: state.AppReducer.user,
        stream: state.AppReducer.stream,
        stream_screen: state.AppReducer.stream_screen,


        // object_worker: state.AppReducer.object_worker,
        provas: state.AppReducer.provas,
        redacoes: state.AppReducer.redacoes,

        faculdade: state.AppReducer.faculdade,
        processo_resultado: state.AppReducer.processo_resultado,



    }
);

export default withRouter(connect(mapsStateToProps, { logout, changeState, mudarProcesso })(Finalizada));
